import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import type { StudentRole } from "@/lib/api";

const ROLES: Record<StudentRole, string> = { student: "student", staff: "staff" };

/**
 * student | staff, compact enough for a table cell. Staff hold real keys to dry-run
 * challenges; the role keeps their runs off leaderboards and out of the Slack sync's
 * "who left".
 */
export function RoleSelect({
  value,
  onChange,
  label = "Role",
}: {
  value: StudentRole;
  onChange: (role: StudentRole) => void;
  label?: string;
}) {
  return (
    <Select items={ROLES} value={value} onValueChange={(next) => next && onChange(next as StudentRole)}>
      <SelectTrigger size="sm" className="w-24 text-xs" aria-label={label}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {(Object.keys(ROLES) as StudentRole[]).map((role) => (
          <SelectItem key={role} value={role}>
            {ROLES[role]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
